var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M12,0A9,9,0,0,0,3,9H0l3.89,3.89L4,13,8,9H5a7,7,0,1,1,2.06,4.94L5.64,15.36A9,9,0,1,0,12,0ZM11,5v5l4.28,2.54L16,11.33,12.5,9.25V5Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }